import { render } from "./UOM.vue?vue&type=template&id=7d57bfe6"
import script from "./UOM.vue?vue&type=script&lang=js"
export * from "./UOM.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__